module.exports = __webpack_public_path__ + "static/media/5f8de7ed5ae7590275f0751e_logo_200x200.a537cbf5.png";